import React, {ComponentProps, useState} from "react";
import {Modal} from "antd";
import PictureViewer from "../product-display/pictureViewer";

interface Props extends ComponentProps<any> {
    label?: string
}

function PictureColumn(props: Props) {
    const {children, label, ...otherProps} = props
    const [visible, setVisible] = useState(false)
    return (
        <>
            <a {...otherProps} onClick={() => setVisible(true)}>{label ||children}</a>
            <Modal visible={visible}
                   onCancel={() => setVisible(false)}
                   width={1000}
                   title={'Picture'}
                   footer={null}
            >
                <PictureViewer style={{width: '100%'}} name={children} quality={''} label={label}/>
            </Modal>
        </>
    )
}

export default PictureColumn
